import styled from "styled-components";

import { Box } from "@similarweb/ui-components/foundations";

export const BoxTextAlignRight = styled(Box)`
    text-align: right;
`;
